{
  "pages": {
    "savings": {
      "title": "Your savings",
      "savingsAchieved": "Savings Achieved",
      "annualSavings": "Annual savings for spend area",
      "noSavings": "You have no savings yet"
    }
  },
  "components": {
    "savingsAchieved": {
      "title": "Savings achieved",
      "total": "Total expected lifetime savings",
      "annual": "Annual savings",
      "activatedSpendAreas": "{{active}} / {{total}} active spend areas",
      "month": "month",
      "monthly": "Monthly savings",
      "noSavings": "You have no savings yet",
      "error": {
        "title": "Failed to load savings achieved data"
      }
    },
    "annualSavingsSummary": {
      "title": "Annual savings for spend areas",
      "filterTitle": "Show for",
      "legend": "Legend",
      "savingCategories": {
        "inScope": "In-scope spend",
        "totalInProgress": "Total spend - analysis in progress",
        "totalComplete": "Total spend - analysis complete",
        "totalIdentified": "Total savings identified",
        "approved": "Savings approved"
      }
    },
    "savingsTable": {
      "actions": {
        "preview": "Preview details"
      },
      "columns": {
        "spendArea": "Spend area",
        "stage": "Stage",
        "savingsIdentified": "Savings identified",
        "savingsApproved": "Savings approved",
        "inScopeSpend": "In-scope spend",
        "details": "Details"
      },
      "footer": {
        "total": "Total"
      },
      "noData": {
        "title": "There are no savings to be shown",
        "description": "There are no available spend areas for the selected area."
      }
    },
    "annualSavings": {
      "title": "Annual savings for spend area"
    },
    "savingsChart": {
      "title": "Spend area",
      "savingsInProgress": "savings in progress",
      "selectPlaceholder": "Select spend area",
      "tooltipPlaceholder": "No savings approved for this area",
      "noData": {
        "title": "There are no savings to be shown",
        "description": "There are no available spend areas or spend categories for the selected area. Please try again later."
      },
      "error": {
        "title": "Failed to load annual savings for spend area data"
      }
    },
    "savingsPlaceholder": {
      "noData": {
        "title": "You have no savings here just yet. We're currently working on getting them here.",
        "description": "They will appear soon"
      },
      "error": {
        "title": "We have a problem with checking your savings",
        "description": "To view your savings, please try refreshing the page. If the issue persists try again later."
      }
    }
  },
  "tooltips": {
    "inScopeSpend": "In-scope spend refers to the total amount you've spent that falls within the scope of a spend areas under audit",
    "totalSpendInProgress": "Total spend - analysis in progress includes expense groups that are still under review",
    "totalSpendComplete": "Total spend - analysis complete includes expense groups that have been fully reviewed",
    "totalSavingsIdentified": "Savings identified refers to the total savings we expect you to achieve by the end of the audit process",
    "savingsApproved": "Savings approved are the identified savings that have been successfully implemented or confirmed",
    "annualSpendCategorySavingsPercentage": "Savings approved for this spend area. The percentage represents its share of your total approved savings"
  }
}
